import type { ReactNode } from 'react';

import { Mascot } from '../../../components';

/**
 * 진단 흐름이 잠깐 멈추고 **말만 하는 화면**의 공통 껍데기 — 주변 소음(`884:9858`),
 * 단계 완료(`884:9451`), 전체 완료(`893:13968`)가 시안에서 같은 레이아웃이다.
 *
 * 셋이 각자 그리면 제목 자간이나 캡슐 색을 시안이 바꾸는 날 세 파일을 따로 고쳐야 하고,
 * 그 중 하나를 빠뜨리면 같은 흐름 안에서 화면마다 글자가 다르게 앉는다.
 *
 * 마스코트는 기본값으로 있다. **경고가 붙은 화면에서는 뺀다**(`showMascot={false}`) —
 * "음정 정확도 0%"를 적어 놓고 마스코트가 웃고 있으면 화면이 두 가지를 동시에 말한다
 * (2026-09-16 실기기: 0% 아래에서 웃는 마스코트).
 */

export const FullScreenNotice = ({
  title,
  banner,
  children,
  footer,
  showMascot = true,
}: {
  /** 제목. 줄바꿈(`\n`)은 시안의 줄 나눔 그대로 살린다. */
  title: string;
  /** 분홍 테두리 캡슐 한 줄 — 무엇을 하면 되는지. */
  banner: string;
  /** 캡슐과 마스코트 사이. 단계 완료의 측정 요약처럼 화면마다 다른 것만 넣는다. */
  children?: ReactNode;
  /** 하단 버튼들. 화면마다 개수와 배치가 달라 통째로 받는다. */
  footer: ReactNode;
  /** 경고를 띄운 화면은 축하 그림을 빼고 여백만 남긴다. */
  showMascot?: boolean;
}) => (
  <div className="flex flex-1 flex-col items-center px-5 pb-8">
    <h2 className="mt-20 whitespace-pre-line text-center text-[22px] font-semibold leading-[1.5] tracking-[-0.11px] text-[hsl(var(--title))]">
      {title}
    </h2>

    <p className="mt-6 whitespace-pre-line rounded-2xl border border-primary/20 bg-primary/[0.03] px-5 py-4 text-center text-sm font-medium leading-[1.6] text-foreground">
      {banner}
    </p>

    {children}

    {showMascot && <Mascot className="mt-10 w-[180px]" />}

    <div className="mt-auto flex w-full gap-3 pt-8">{footer}</div>
  </div>
);
